<template>
  <v-card
      color="#fff"
      class="post_card mx-2 mx-sm-3 mb-6 mb-sm-12"
      elevation="0"
      :max-width="$vuetify.breakpoint.lgAndUp ? '520px' : '100%'"
  >
    <div class="post_logo">
      <img :src="post.display_thumb_url" :data-id="post.id" alt="photo" style="aspect-ratio: 3 / 4.5;"/>
    </div>
    <div class="post_info">
      <div class="post_views d-flex">
        <img
            class="mt-1 mr-3"
            src="../assets/eye_dark.svg"
            alt="views"
        />
        <span class="mt-2">{{ post.views_count }}</span>
      </div>
      <div class="post_views d-flex">
        <img class="mr-3" src="../assets/like_dark.svg" alt="likes"/>
        <span class="mt-2">{{ post.likes_count }}</span>
      </div>
    </div>
    <div v-if="post.title" class="post_title text-center py-6">
      {{ post.title }}
    </div>
    <div v-else style="margin-bottom:29px"></div>
    <div class="post_btn text-center pb-6">
      <v-btn
          :disabled="status === 'suspend'"
          color="#76CD68"
          height="50"
          class="order_followers buy_btn mb-2"
          dark
          depressed
          rounded
          @click="() => buy_more = true"
      >
        Get Likes/Views
      </v-btn>
    </div>

    <v-expand-transition>
      <div
          v-if="buy_more"
          class="transition-fast-in-fast-out transition_card"
      >
        <div class="post_title text-center my-6">
          <!--                    {{ post.title }}-->
        </div>
        <div class="mx-6">
          <div class="scroller d-flex ml-auto mr-auto align-center mt-6 mt-lg-0">
          <v-slider
              thumb-color="#2C4370"
              thumb-size="23px"
              tick-size="10"
              :loader-height="10"
              hide-details=""
              v-model="order_likes"
              track-color="#EEF4FF"
              track-fill-color="#ACBFE3"
              :min="scores.likes < scores.minLikes ? 0 : scores.minLikes"
              :max="scores.likes >= scores.minLikes ? scores.likes : 0"
          >
            <template v-slot:prepend>
              <v-icon
                  @click="decrementLikes"
              >
                mdi-minus
              </v-icon>
            </template>

            <template v-slot:append>
              <v-icon
                  @click="incrementLikes"
              >
                mdi-plus
              </v-icon>
            </template>
          </v-slider>
        </div>
        </div>
        <div class="d-flex mx-8 my-4 justify-space-between">
          <div class="post_views d-flex align-center">
            <img class="mr-2" src="../assets/like_dark.svg" alt="likes"/>
            <v-text-field
                v-if="scores.likes >= scores.minLikes"
                ref="likesInput"
                type="number"
                style="max-width: 88px"
                class="v-text-input"
                v-model="order_likes"
                :min="scores.likes < scores.minLikes ? 0 : scores.minLikes"
                :step="1"
                @blur="validateLikes"
                @click="likes_ordered=false"
            ></v-text-field>
            <v-text-field
                v-else
                ref="followersInput"
                style="max-width: 88px"
                class="v-text-input"
                v-model="textNoLikes"
                disabled
                :hint="scores.likes < scores.minLikes ? 'min ' + scores.minLikes : ''"
                persistent-hint
            >
            </v-text-field>
            <!--                        <span class="mt-2">{{ post.likes_count + order_likes }}</span>-->
          </div>
          <template v-if="scores.likes >= scores.minLikes">
            <template v-if="!likes_ordered_success">
              <v-btn
                  v-if="order_likes"
                  :color="!likes_ordered ? '#2C4370' : '#76CD68'"
                  width="107px"
                  height="50"
                  class="buy_btn"
                  :outlined="!likes_ordered"
                  :dark="likes_ordered"
                  rounded
                  @click="() => {!likes_ordered ? likes_ordered = true : handleOrder('likes') }"
              >
                {{ !likes_ordered ? 'Order' : 'I am sure' }}
              </v-btn>

              <v-btn
                  v-if="likes_ordered"
                  color="#9F4343"
                  width="50px"
                  height="50px"
                  class="mx-2"
                  outlined
                  rounded
                  @click="() => {likes_ordered = false}"
              >
                No
              </v-btn>
            </template>
            <template v-else>
              <v-btn
                  color="#81EF7F"
                  width="107px"
                  height="50"
                  class="buy_btn"
                  outlined
                  rounded
                  @click="() => {likes_ordered_success = false}"
              >
                <img src="../assets/ok_green.svg" alt="ok"/>
              </v-btn>
            </template>
          </template>
          <template v-else>
            <ModalSelectFollowers
                v-bind:slug="'tiktok'"
                v-bind:typeProduct="'likes'"
                v-bind:singleData="singleData"
            />
          </template>
        </div>
        <div class="mx-6">
        <div class="scroller d-flex ml-auto mr-auto align-center mt-6 mt-lg-0">
          <v-slider
              thumb-color="#2C4370"
              thumb-size="23px"
              tick-size="1"
              :loader-height="10"
              hide-details=""
              v-model="order_views"
              track-color="#EEF4FF"
              track-fill-color="#ACBFE3"
              :max="scores.views >= scores.minViews ? scores.views : 0"
              :min="scores.views < scores.minViews ? 0 : scores.minViews"
          >
            <template v-slot:prepend>
              <v-icon
                  @click="decrementViews"
              >
                mdi-minus
              </v-icon>
            </template>

            <template v-slot:append>
              <v-icon
                  @click="incrementViews"
              >
                mdi-plus
              </v-icon>
            </template>
          </v-slider>
        </div>
        </div>
        <div class="d-flex mx-8 my-4 justify-space-between">
          <div class="post_views d-flex align-center">
            <img class="mr-2" src="../assets/eye_dark.svg" alt="likes"/>
            <v-text-field
                v-if="scores.views >= scores.minViews"
                ref="viewsInput"
                type="number"
                class="v-text-input"
                v-model="order_views"
                :max="scores.views >= scores.minViews ? scores.views : 0"
                :min="scores.views < scores.minViews ? 0 : scores.minViews"
                :step="1"
                @blur="validateViews"
                @click="views_ordered=false"
            ></v-text-field>
            <v-text-field
                v-else
                ref="followersInput"
                style="max-width: 110px"
                class="v-text-input"
                v-model="textNoViews"
                disabled
                :hint="scores.views < scores.minViews ? 'min ' + scores.minViews : ''"
                persistent-hint
            >
            </v-text-field>
            <!--                        <span class="mt-2">{{ post.views_count + order_views }}</span>-->
          </div>
          <template v-if="scores.views >= scores.minViews">
            <template v-if="!views_ordered_success">
              <v-btn
                  v-if="order_views"
                  :color="!views_ordered ? '#2C4370' : '#76CD68'"
                  width="107px"
                  height="50"
                  class="buy_btn"
                  :outlined="!views_ordered"
                  :dark="views_ordered"
                  rounded
                  @click="() => {!views_ordered ? views_ordered = true : handleOrder('views') }"
              >
                {{ !views_ordered ? 'Order' : 'I am sure' }}
              </v-btn>

              <v-btn
                  v-if="views_ordered"
                  color="#9F4343"
                  width="50px"
                  height="50px"
                  class="mx-2"
                  outlined
                  rounded
                  @click="() => {views_ordered = false}"
              >
                No
              </v-btn>
            </template>

            <template v-else>
              <v-btn
                  color="#81EF7F"
                  width="107px"
                  height="50"
                  class="buy_btn"
                  outlined
                  rounded
                  @click="() => {views_ordered_success = false}"
              >
                <img src="../assets/ok_green.svg" alt="ok"/>
              </v-btn>
            </template>
          </template>
          <template v-else>
            <ModalSelectFollowers
                v-bind:slug="'tiktok'"
                v-bind:typeProduct="'views'"
                v-bind:singleData="singleData"
            />
          </template>
        </div>
        <div class="mt-6 text-center mb-6">
          <v-btn
              color="#2C4370"
              width="137px"
              height="50"
              class="mb-2"
              outlined
              rounded
              @click="() => buy_more = false"
          >
            Close
          </v-btn>
        </div>
      </div>
    </v-expand-transition>
    <v-slide-y-transition>
      <div
          v-if="buy_more"
          class="transition-fast-in-fast-out top_transition"
      >
        <div class="post_info">
          <div class="post_views d-flex">
            <img
                class="mt-1 mr-3"
                src="../assets/eye_dark.svg"
                alt="views"
            />
            <span class="mt-2">{{ post.views_count }}</span>
          </div>
          <div class="post_views d-flex">
            <img class="mr-3" src="../assets/like_dark.svg" alt="likes"/>
            <span class="mt-2">{{ post.likes_count }}</span>
          </div>
        </div>
      </div>
    </v-slide-y-transition>
  </v-card>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import vue from 'vue'
import { updateCounts } from '../utils/utils'
import ModalSelectFollowers from '../components/ModalSelectFollowers'

export default {
  name: 'TiktokPostCard',
  props: ['post', 'scores', 'singleData'],
  components: { ModalSelectFollowers },
  data () {
    return {
      textNoViews: this.scores.views,
      textNoLikes: this.scores.likes,
      buy_more: false,
      order_likes_processing: false,
      order_likes: 0,
      likes_ordered: false,
      likes_ordered_success: false,
      order_views_processing: false,
      order_views: 0,
      views_ordered: false,
      views_ordered_success: false
    }
  },
  computed: {
    ...mapGetters("user", ["status"]),
  },
  methods: {
    ...mapActions('order', ['createNewOrder']),
    decrementLikes () {
      this.order_likes--
    },
    incrementLikes () {
      this.order_likes++
    },
    decrementViews () {
      this.order_views--
    },
    incrementViews () {
      this.order_views++
    },
    validateViews (event) {
      const count = updateCounts(event, this.scores.minViews, this.scores.views)
      vue.set(this, 'order_views', count)
      this.$refs.viewsInput.lazyValue = count
      this.$refs.viewsInput.initialValue = count
      event.target.value = count
    },
    validateLikes (event) {
      const count = updateCounts(event, this.scores.minLikes, this.scores.likes)
      this.$refs.likesInput.lazyValue = count
      this.$refs.likesInput.initialValue = count
      vue.set(this, 'order_likes', count)
      event.target.value = count
    },
    handleOrder (type) {
      if (this[`order_${type}`] < 1) {
        return
      }
      if (this[`order_${type}_processing`]) {
        return
      }
      this[`order_${type}_processing`] = true
      this.createNewOrder({
        id: this.post.id,
        serviceId: type === 'likes' ? 5 : 7,
        quantity: this[`order_${type}`],
      }).then((data) => {
        console.log(data);
        this[`order_${type}`] = 0
        this[`${type}_ordered`] = false
        this[`order_${type}_processing`] = false
        this[`${type}_ordered_success`] = true
      }).catch(() => {
        this[`${type}_ordered`] = false
        this[`order_${type}_processing`] = false
      })
    },
  },
}
</script>
<style scoped>
.transition-fast-in-fast-out.top_transition {
  transition: all 0.1s cubic-bezier(1, 0.5, 0.8, 1) !important;
}

.v-input {
  min-width: 68px !important;
  margin-left: 5px;
}
</style>
